import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var responseSchema = yup.object({
  cancelationFee: yup.number().required(),
});

var composeResponse = (response) => {
  let result = {};
  if (response && response.data.data) {
    result = {
      cancelationFee: Number(response.data.data.cancellation_fee) || 0,
    };
  }
  return result;
};

export function useAppointmentFeesQuery({ appointmentId }, options = {}) {
  return useQuery(
    [QUERY_KEYS.appointments.fees, appointmentId],
    async () => {
      var res = await http.get(
        HTTP_ENDPOINTS.appointments.getFees(appointmentId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
